import { useLocalization } from "../context/LocalizationContext";

const NotAuthorized = () => {
 
  const { t: localization } = useLocalization();
  return (
    <div style={{ minHeight: 'calc(100vh - 56px)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <div className="not-authorized">
        <div className="content-wrapper ">
          <div className="alert-warning text-center not-authorized-content">
            <div className="icon">
              <img src="../assets/images/illustrations/close-icon.svg" alt="Dealer Not Assigned Icon" />
            </div>
            <h5>{localization("not_authorized")}</h5>
            <p>{localization("not_authorized_message")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotAuthorized;